import React, { ReactNode } from 'react';

import CenteredLayoutContainer from 'components/CenteredLayoutContainer';
import { H1 } from 'components/Heading';

import { Layout } from './Layout';

type Props = {
  title?: string;
  children: ReactNode;
};

export function CenteredLayout({ title, children }: Props) {
  return (
    <Layout defaultWithSearchHero={false}>
      <CenteredLayoutContainer
        pt={[null, null, null, 60]}
        pb={[null, null, null, 40]}
      >
        {title && <H1 styleAs="h2">{title}</H1>}
        {children}
      </CenteredLayoutContainer>
    </Layout>
  );
}
